import React from "react"
import "./ClientsTicker.css"

import mts from "../assets/clients/mts-home-group.png"
import gsc from "../assets/clients/great-southern-chiropractic.png"
import nh from "../assets/clients/natural-healing.png"
import hyrmind from "../assets/clients/hyrmind.png"
import smt from "../assets/clients/sturt-marion-thunder.png"
import saw from "../assets/clients/stride-and-wag.png"
import pathways from "../assets/clients/2mer-pathways-alliance.png"
import rolla from "../assets/clients/rolla-construction.png"
import spinal from "../assets/clients/spinal-flow-vitality.png"
import fiona from "../assets/clients/fiona-schubert.png"
import coffee from "../assets/clients/coffee-bus.png"
import morningside from "../assets/clients/morningsidechiro.png"
import wrench from "../assets/clients/wrench-wagon.png"
import nitschke from "../assets/clients/nitschke.png"
import interlock from "../assets/clients/interlock.png"
import phoenix from "../assets/clients/phoenix-spinal-flow.png"
import jesse from "../assets/clients/jessebtattoos.png"
import ruga from "../assets/clients/ruga.webp"
import waiwilta from "../assets/clients/waiwilta.png"

const clients = [
  { title: "MTS Home Group", liveLink: "https://mtshomegroup.com.au/", image: mts },
  { title: "Great Southern Chiropractic", liveLink: "https://www.greatsouthernchiropractic.com", image: gsc },
  { title: "Natural Healing", liveLink: "https://natural-healing.life/", image: nh },
  { title: "HyrMind", liveLink: "https://hyrmind.com", image: hyrmind },
  { title: "Sturt Marion Thunder", liveLink: "https://sturtmarionthunder.com.au/", image: smt },
  { title: "Stride and Wag Animal Chiropractor", liveLink: "https://strideandwag.com", image: saw },
  { title: "2mer Pathways Alliance", liveLink: "https://2merpathwaysalliance.live", image: pathways },
  { title: "Rolla Construction", liveLink: "https://rollacon.com.au", image: rolla },
  { title: "Spinal Flow Vitality", liveLink: "https://spinalflowvitality.com.au/", image: spinal },
  { title: "Morningside Chiropractic", liveLink: "https://morningsidechiro.com.au/", image: morningside },
  { title: "The CoffeeSchool Bus", liveLink: "https://thecoffeeschoolbus.com.au", image: coffee },
  { title: "Fiona Schubert", liveLink: "https://fionaschubert.com.au", image: fiona },
  { title: "Wrench Wagon", liveLink: "https://wrenchwagon.com.au", image: wrench },
  { title: "Nitschke", liveLink: "https://nitschke.com.au", image: nitschke },
  { title: "Interlock", liveLink: "https://interlockgroup.tech", image: interlock },
  { title: "Phoenix Spinal Flow", liveLink: "https://phoenixspinalflow.com.au", image: phoenix },
  { title: "Jesse B Tattoos", liveLink: "https://jessebtattoos.com", image: jesse },
  { title: "Ruga", liveLink: "https://rugascafe.com.au", image: ruga },
  { title: "Waiwilta", liveLink: "https://waiwilta.org.au", image: waiwilta },
]

const midpoint = Math.ceil(clients.length / 2)
const topRow = clients.slice(0, midpoint)
const bottomRow = clients.slice(midpoint)

function TickerRow({ items, reverse = false }) {
  const loop = [...items, ...items]

  return (
    <div className="ticker-row" data-reverse={reverse ? "true" : "false"}>
      <div className="ticker-track">
        {loop.map((client, i) => (
          <a
            key={`${client.title}-${i}`}
            href={client.liveLink}
            target="_blank"
            rel="noopener noreferrer"
            className="ticker-item"
            title={client.title}
          >
            <div className="ticker-logo-wrap">
              <img
                src={client.image}
                alt={`${client.title} logo`}
                loading="lazy"
                className="ticker-logo"
              />
              <span className="ticker-label">{client.title}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}

export default function PortfolioSlider() {
  return (
    <section className="relative z-10 bg-gradient-to-b from-[#eef5ff] via-brand-bg to-brand-surface py-section">
      <div className="mx-auto max-w-[1180px] px-6">
        <div className="mx-auto mb-12 max-w-[760px] text-center">
          <p className="mb-4 inline-flex items-center gap-2 text-[0.78rem] font-bold uppercase tracking-[0.16em] text-brand-primary">
            Recent work
          </p>

          <h2 className="mb-4 text-[clamp(2rem,3vw,3.3rem)] leading-[1.1] text-brand-heading">
            Clients
          </h2>

          <p className="text-[1.05rem] leading-[1.75] text-brand-textSoft">
            We build fast, modern websites for South Australian small businesses,
            health and wellness clinics, construction and trade services,
            hospitality brands, creative studios, and community organisations.
          </p>

          <p className="mt-4 text-[1.05rem] leading-[1.75] text-brand-textSoft">
            Our recent work includes chiropractic and Spinal Flow clinics,
            natural healing and wellbeing providers, an animal chiropractor,
            construction and building businesses, a mobile coffee brand, a
            creative artist portfolio, and local sporting clubs.
          </p>

          <p className="mt-4 text-[1.05rem] leading-[1.75] text-brand-textSoft">
            Each project is collaborative. We listen first, then deliver a site
            that fits your brand, loads quickly, and makes it easy for customers
            to book, call, enquire, buy, or find you locally.
          </p>

          <p className="mt-4 text-[1.05rem] leading-[1.75] text-brand-textSoft">
            We also support local visibility through Google Business Profile
            setup and optimisation, including categories, service areas, posts,
            photos, and review workflows that help you show up in Google Search
            and Maps.
          </p>
        </div>

        <div className="rounded-xl3 border border-brand-border bg-brand-surface p-6 shadow-cardStrong sm:p-8">
          <div className="ticker-wrap" role="region" aria-label="Client logos ticker">
            <TickerRow items={topRow} />
            <div className="ticker-gap" />
            <TickerRow items={bottomRow} reverse />
          </div>
        </div>
      </div>
    </section>
  )
}